import Vue from 'vue';
import Vuelidate from 'vuelidate';

import store from './store';
import './filters/currency';

import App from './components/App.vue';

const id = 'quote-tool-app';

const container = document.getElementById(id);

if (container) {
    Vue.use(Vuelidate);

    new Vue({
        el: `#${id}`,
        render: h => h(App),
        store,
    })
}